import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PayCreditComponent } from './pay-credit.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';

import { DxSpeedDialActionModule, DxFileUploaderModule, DxButtonModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxRadioGroupModule, DxCheckBoxModule, DxAccordionModule, DxTabPanelModule, DxAutocompleteModule, DxNumberBoxModule, DxDropDownButtonModule, DxTabsModule, DxTemplateModule, DxTextAreaModule, DxToolbarModule, DxTreeViewModule, DxSortableModule, DxDiagramModule, DxTreeListModule, DxHtmlEditorModule, DxDropDownBoxModule, DxTooltipModule, DxSwitchModule } from "devextreme-angular";
// import { FindReplaceEstimateComponent } from './find-replace-estimate/find-replace-estimate.component';
@NgModule({
  declarations: [
    PayCreditComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DashboardModule,
    DxButtonModule,
    DxTagBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxAccordionModule,
    DxTabPanelModule,
    DxAutocompleteModule,
    DxNumberBoxModule,
    DxDropDownButtonModule,
    DxDropDownBoxModule,
    DxTabsModule,
    DxTemplateModule,
    DxTextAreaModule,
    DxToolbarModule,
    DxTreeViewModule,
    DxSortableModule,
    DxDiagramModule,
    DxFileUploaderModule,
    DxTreeListModule,
    DxHtmlEditorModule,
    DxTooltipModule,
    DxSpeedDialActionModule,
    DxSwitchModule,
  ],
  exports: [
    PayCreditComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PayCreditModule { }
